import React, { useCallback } from 'react';

// Custom styles for the Badge to display
const UpwardBadge = (props) => {
   const onClose = useCallback((event) => {
      if (props.closeAble && props.onClose) {
         props.onClose();
      }
      event.preventDefault();
      event.stopPropagation();
   }, [props.onClose]);
   const onBadgeClick = useCallback((event) => {
      if (props.onClick) {
         props.onClick(event);
      }
   }, [props.onClick]);
   return (
      <span style={{ cursor: 'pointer' }} onClick={onBadgeClick} className={`badge badge-pill upward-badge badge-gray2 mt-2 py-1 px-2 mr-2 ${ props.className ? props.className : '' }`}>{props.content} {props.closeAble && <button type='button' className='close' onClick={onClose} ><span aria-hidden='true'>&times;</span></button>}</span>
   );
};

export default UpwardBadge;
